module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAb1BMVEX///9gZHBkaHP8/P39/f1iZnJzd4Hw8PG1t7zt7e/5+fppbHhmanaTlp51eYT29/fu7vDp6uvm5ujc3d/W2NuusLaBhI27vcKQk5uNkJh8f4l7fohvc35rbnry8vPf4OLR09arrbSdn6aXmqKIi5RFnalSAAAAtklEQVQoz82PWQ6CMAAFeYWWVvZ9EXfvf0a7oUEBjV/Mz+Rl0jZ1NoBItfJ8XBN2CIxCu94y2yu5fT2uKUJo+f6oCR6o0cEo+C8HRuFCDj/ymWEWVurMsECsM9APibQP6P9kgJoJYHONQpoDXO0KaKTKZ77gnglOKCVcZBWlCHma16A2HwdIKOdUmTQVNMRmx7/FLJIPFBGLo5O8WPr6ynN4283uL6dbAGQWAK3TYYVOvrGC84UHb0EHqrc1d0MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/storagedetail/img/birthday.png
// module id = 744
// module chunks = 0